import React, { useState } from "react";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { Button, FormControl, Modal, Typography, CircularProgress } from "@mui/material";
import { toast } from "mdbreact";
import axios from "../../../../axios";
import Select from "react-select";
function QuickSearchToolbar() {
    return (
        <Box
            sx={{
                p: 0.5,
                pb: 0,
            }}
        >
            <GridToolbarQuickFilter />
        </Box>
    );
}
export default function Basic(props) {
 const [loadingRoles, setLoadingRoles] = useState({});
     const [updateModal, setUpdateModal] = useState({ open: false, email: '', role: '' });
     const roleOptions = [
         { value: "DomainAdministrator", name: "Domain Administrator" },
         { value: "SIEMAdministrator", name: "SIEM Administrator" },
         { value: "AccountManager", name: "Account Manager" },
         { value: "CustomerSupport", name: "Customer Support" },
     ];
     const updateAdministratorRole = async (email, newRole, rowId) => {
         const newRoleName = roleOptions.find(role => role.value === newRole)?.name || newRole;
         setUpdateModal({ open: true, email, role: newRoleName });
         setLoadingRoles(prev => ({ ...prev, [rowId]: true }));
         try {
             // First, disable staff access
             const disableBody = {
                 AccessToken: sessionStorage.getItem("AccessToken"),
                 EmailAddress: email
             };
             await axios.post("/networkoperatorconsole/staff/disableStaffAccess", disableBody, {
                 headers: {},
             });
             // Then, enable staff access with new role
             const enableBody = {
                 AccessToken: sessionStorage.getItem("AccessToken"),
                 EmailAddress: email,
                 Role: newRole,
                 GivenName: email.split('@')[0], // Fallback to email prefix
                 FamilyName: "",
                 Language: "en-us"
             };
             await axios.post("/networkoperatorconsole/staff/enableStaffAccess", enableBody, {
                 headers: {},
             });
             // Show success notification
             toast.success(`Administrator role successfully updated to ${newRoleName}`, {
                 closeButton: false,
                 autoClose: 4000,
             });
             // Refresh the administrators table
             if (props.refreshAdministratorsTable) {
                 props.refreshAdministratorsTable();
             }
         } catch (error) {
             console.error("Error updating administrator role:", error);
             toast.error("Failed to update administrator role. Please try again.", {
                 closeButton: false,
                 autoClose: 5000,
             });
         } finally {
             setLoadingRoles(prev => ({ ...prev, [rowId]: false }));
             setUpdateModal({ open: false, email: '', role: '' });
         }
     };
    const RoleDropdown = ({ row }) => {
            // Handle the role value properly - convert array to string and find matching role
            const roleValue = Array.isArray(row.type) ? row.type[0] : row.type.toString();
            const currentRole = roleOptions.find(option => 
                option.value === roleValue || option.name === roleValue
            )?.value || roleValue;
            const isLoading = loadingRoles[row.id];
            const isCustomerSupport = sessionStorage.getItem("customerSupport") === "1";
            // Convert roleOptions to react-select format, filtering out DomainAdministrator for Customer Support users
            let selectOptions = roleOptions
                .filter(option => {
                    // If user is Customer Support, exclude DomainAdministrator option
                    if (isCustomerSupport && option.value === "DomainAdministrator") {
                        return false;
                    }
                    return true;
                })
                .map(option => ({
                    label: option.name,
                    value: option.value
                }));
            // Add fallback option if current role doesn't match predefined options
            if (!roleOptions.find(option => option.value === currentRole)) {
                selectOptions.push({
                    label: currentRole,
                    value: currentRole
                });
            }
            // Find the current option for react-select
            const selectedOption = selectOptions.find(option => option.value === currentRole) || null;
            const handleChange = (selectedOption) => {
                if (selectedOption) {
                    updateAdministratorRole(row.email, selectedOption.value, row.id);
                }
            };
            // Custom styles to match Material-UI
            const customStyles = {
                control: (provided, state) => ({
                    ...provided,
                    minHeight: '40px',
                    height: '40px',
                    minWidth: '200px',
                    fontSize: '0.875rem',
                    fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                    backgroundColor: isLoading ? '#e9ecef' : '#f8f9fa',
                    // border: state.isFocused ? '2px solid #0d6efd' : '1px solid #dee2e6',
                    borderRadius: '5px',
                    boxShadow: state.isFocused ? '0 0 0 3px rgba(13, 110, 253, 0.1)' : 'none',
                    cursor: isLoading ? 'not-allowed' : 'pointer',
                }),
                valueContainer: (provided) => ({
                    ...provided,
                    height: '38px',
                    padding: '0 8px 0 14px',
                }),
                singleValue: (provided) => ({
                    ...provided,
                    color: isLoading ? '#6c757d' : '#333',
                    fontSize: '0.875rem',
                }),
                indicatorsContainer: (provided) => ({
                    ...provided,
                    height: '38px',
                }),
                indicatorSeparator: () => ({
                    display: 'none',
                }),
                dropdownIndicator: (provided) => ({
                    ...provided,
                    color: isLoading ? '#adb5bd' : '#6c757d',
                    padding: '8px',
                    '& svg': {
                        display: 'none', // Hide the default arrow
                    },
                    '&:after': {
                        content: '"▼"', // Solid down arrow
                        fontSize: '12px',
                        color: isLoading ? '#adb5bd' : '#6c757d',
                    },
                    '&:hover': {
                        color: isLoading ? '#adb5bd' : '#0d6efd',
                        '&:after': {
                            color: isLoading ? '#adb5bd' : '#0d6efd',
                        },
                    },
                }),
                menu: (provided) => ({
                    ...provided,
                    borderRadius: '5px',
                    border: '1px solid #f5f5f5',
                    backgroundColor: '#f5f5f5',
                    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
                    marginTop: '4px',
                    // zIndex: 10000,
                }),
                menuList: (provided) => ({
                    ...provided,
                    padding: '0',
                    borderRadius: '5px',
                    maxHeight: '240px',
                }),
                option: (provided, state) => ({
                    ...provided,
                    fontSize: '0.875rem',
                    fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                    padding: '10px 16px',
                    backgroundColor: state.isSelected 
                        ? '#e7f3ff' 
                        : state.isFocused 
                            ? 'var(--primary-color, #007bff)' 
                            : '#f5f5f5',
                    color: state.isSelected 
                        ? '#0d6efd' 
                        : state.isFocused 
                            ? '#ffffff' 
                            : '#333333',
                    fontWeight: state.isSelected ? 500 : 'normal',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: state.isSelected ? '#cce7ff' : 'var(--primary-color, #007bff)',
                        color: state.isSelected ? '#0d6efd' : '#ffffff',
                    },
                }),
                placeholder: (provided) => ({
                    ...provided,
                    color: '#6c757d',
                    fontSize: '0.875rem',
                }),
            };
            return (
                <div onClick={(e) => e.stopPropagation()} style={{ position: 'relative', zIndex: 1000 }}>
                    <FormControl size="small" sx={{ minWidth: 200 }}>
                        <Select
                            value={selectedOption}
                            onChange={handleChange}
                            options={selectOptions}
                            isDisabled={isLoading}
                            isSearchable={false}
                            placeholder="Select a role"
                            styles={{
                                ...customStyles,
                                menuPortal: (provided) => ({ 
                                    ...provided, 
                                    zIndex: 9999999 
                                })
                            }}
                            menuPlacement="auto"
                            menuPosition="absolute"
                            menuPortalTarget={document.body}
                            onMouseDown={(e) => e.stopPropagation()}
                        />
                    </FormControl>
                </div>
            );
        };
    let userAttributes = [];
    let i = 0;
    let columns = [];
    let rows = [];
    if (props.administratorsData !== undefined) {
        for (const key of Object.keys(props.administratorsData)) {
            userAttributes.push({
                id: key,
                email: Object.keys(props.administratorsData[key]).toString(),
                type: Object.values(props.administratorsData[key]),
            });
            i = i + 1;
        }
    }
    columns = [
        {
            headerName: "Email Address",
            field: "email",
            minWidth: 400,
        },
        {
            headerName: "Role",
            field: "type",
            minWidth: 250,
            renderCell: (params) => {
                const isCustomerSupport = sessionStorage.getItem("customerSupport") === "1";
                const roleValue = Array.isArray(params.row.type) ? params.row.type[0] : params.row.type.toString();
                const isDomainAdministrator = roleValue === "DomainAdministrator" || roleValue === "Domain Administrator";
                const isAccountManager = roleValue === "AccountManager" || roleValue === "Account Manager";
                const isSIEMAdministrator = roleValue === "SIEMAdministrator" || roleValue === "SIEM Administrator";
                if (isCustomerSupport) {
                    // Just show the role text without dropdown for customer support users when role is restricted
                    const roleName = roleOptions.find(option => 
                        option.value === roleValue || option.name === roleValue
                    )?.name || roleValue;
                    return (
                        <Typography 
                            variant="body2" 
                            sx={{ 
                                fontSize: '0.875rem',
                                fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
                                color: '#333',
                                padding: '10px 14px'
                            }}
                        >
                            {roleName}
                        </Typography>
                    );
                }
                return <RoleDropdown row={params.row} />;
            },
        },
        {
            headerName: "Action",
            field: "receipt",
            minWidth: 300,
            renderCell: (params) => {
                const isCustomerSupport = sessionStorage.getItem("customerSupport") === "1";
                const roleValue = Array.isArray(params.row.type) ? params.row.type[0] : params.row.type.toString();
                const isDomainAdministrator = roleValue === "DomainAdministrator" || roleValue === "Domain Administrator";
                return (
                    <div>
                        <Button
                            onClick={(e) => {
                                e.stopPropagation();
                                try {
                                    if (props.resendActivation && typeof props.resendActivation === 'function') {
                                        props.resendActivation(params.row.email);
                                    } else {
                                        console.error('resendActivation prop is not a function:', typeof props.resendActivation, props.resendActivation);
                                        console.error('Available props:', Object.keys(props));
                                    }
                                } catch (error) {
                                    console.error('Error calling resendActivation:', error);
                                }
                            }}
                            rel="noreferrer"
                        >
                            Resend Activation
                        </Button>
                        {!isCustomerSupport && (
                            <Button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    try {
                                        if (props.toggleDisable && typeof props.toggleDisable === 'function') {
                                            props.toggleDisable(params.row.email);
                                        } else {
                                            console.error('toggleDisable prop is not a function:', typeof props.toggleDisable, props.toggleDisable);
                                            console.error('Available props:', Object.keys(props));
                                        }
                                    } catch (error) {
                                        console.error('Error calling toggleDisable:', error);
                                    }
                                }}
                                rel="noreferrer"
                            >
                                Delete
                            </Button>
                        )}
                    </div>
                );
            },
        },
    ];
    rows = userAttributes;
    return (
     <>
     <Modal
                     open={updateModal.open}
                     onClose={() => {}} // Prevent manual closing during update
                     aria-labelledby="update-modal-title"
                     aria-describedby="update-modal-description"
                     style={{
                         position: 'fixed',
                         top: 0,
                         left: 0,
                         width: '100vw',
                         height: '100vh',
                         zIndex: 9999999
                     }}
                 >
                     <Box
                         sx={{
                             position: 'fixed',
                             top: '50%',
                             left: '50%',
                             transform: 'translate(-50%, -50%)',
                             width: 400,
                             bgcolor: 'background.paper',
                             borderRadius: '12px',
                             boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                             p: 4,
                             outline: 'none',
                             textAlign: 'center',
                             zIndex: 9999999
                         }}
                     >
                         <CircularProgress 
                             size={48} 
                             sx={{ 
                                 color: '#0d6efd', 
                                 mb: 2 
                             }} 
                         />
                         <Typography 
                             id="update-modal-title" 
                             variant="h6" 
                             component="h2"
                             sx={{ 
                                 mb: 1,
                                 fontWeight: 600,
                                 color: '#333'
                             }}
                         >
                             Updating Administrator Role
                         </Typography>
                         <Typography 
                             id="update-modal-description" 
                             sx={{ 
                                 color: '#666',
                                 fontSize: '0.9rem'
                             }}
                         >
                             Updating {updateModal.email} to {updateModal.role}...
                         </Typography>
                     </Box>
                 </Modal>
        <div style={{ height: 300, width: "100%" }}>
         <Typography 
                             variant="body2" 
                             sx={{ 
                                 mb: 2, 
                                 color: '#666', 
                                 fontStyle: 'italic',
                                 backgroundColor: '#f8f9fa',
                                 padding: '8px 12px',
                                 borderRadius: '6px',
                                 border: '1px solid #dee2e6'
                             }}
                         >
                             <strong>Note:</strong> If you want a user to have multiple roles, please add the user once for each role.
                         </Typography>
            <DataGrid
                rows={rows}
                columns={columns}
                hideFooterPagination={false}
                hideFooter={false}
                getRowHeight={({ id, densityFactor }) => {
                    return 50 * densityFactor;
                }}
                slots={{ toolbar: QuickSearchToolbar }}
            />
        </div>
        </>
    );
}
